<template>
  <!--v-contextmenu:contextmenu-->
  <div class="container"
       v-loading="loading"
       element-loading-text="加载中,请稍候"
       element-loading-spinner="el-icon-loading">
    <el-row :style="{height:tableHeight+'px'}">
      <el-scrollbar style="height:100%">
        <ul>
          <li @dblclick="dbclick(item)"
              @click="onclick(item)"
              v-for="item in taskGroupCurrent"
              :key="item.ID"
              @contextmenu.prevent="liContextmenu(item)">
           
              <div class="viewbox">
                <div class="svgshow">
                  <svg class="icon alSvgIcon"
                      aria-hidden="true">
                    <use :xlink:href="'#'+getTaskType(item)" />
                  </svg>
                </div>
                
                <!-- <template slot-scope="scope">
                  <div class="title">{{item.TASKNAME}}</div>
                </template> -->
                 <!-- <el-tooltip :content="item.TASKNAME"
                        placement="bottom"
                        effect="dark">
                  <div class="title">{{item.TASKNAME | ellipsis}}</div>
                </el-tooltip> -->
                 <el-tooltip v-if="item.TASKNAME.length>8" :content="item.TASKNAME"
                        placement="bottom"
                        effect="dark">
                  <div class="title">{{item.TASKNAME | ellipsis}}</div>
                </el-tooltip>
                <div class="title" v-else>{{item.TASKNAME}}</div>
              </div>
            
          </li>
        </ul>
      </el-scrollbar>
    </el-row>
    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="open()">打开</v-contextmenu-item>
      <v-contextmenu-item @click="handleFolderMenuClick()">详情</v-contextmenu-item>
      <v-contextmenu-item @click="workRecordDetail()">工作记录</v-contextmenu-item>
    </v-contextmenu>
    <contextMenu ref="contextMenu"
                 :contextMenu="contextmenuRow"></contextMenu>

    <workRecordDialog ref="workRecordDialog"></workRecordDialog>
    <CreateTask
        ref="CreateTask"
        :refreshType="0"
        @getValue="getList"
      ></CreateTask>
  </div>
</template>
<script>
import treeToArray from "@/util/EvalDataToTree";
import workRecordDialog from "../taskGroup/workRecordDialog.vue";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { AddTaskViewHistory } from "@/api/modules/basicData/task";
import {
    GetSubTaskTreePathByTaskId
} from "@/api/modules/basicData/basicTask";
export default {
  name: "taskGroupCurrent",
  components: {
    workRecordDialog,
    contextMenu: () => import("@/views/task/common/contextmenu.vue"),
    CreateTask:() => import("../common/CreateTask.vue"),
  },
  props: {},
  data() {
    return {
      taskGroupCurrent:[],
      resizeTimer: null, // 自适应高度的定时器
      taskIds: [],
      expandAll: false, // 表格是否展开
      selectedRow: null, // 当前选择的行的数据
      contextmenuRow: {},
      TaskType: JSON.parse(localStorage.getItem("TaskType")),
      listHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight - 1000, //（这里的240是减去表格上面导航和搜索条件的高度）
      columns: [
        // 列
        {
          text: "任务单号",
          value: "INSTANCE"
        },
        {
          text: "任务类型",
          value: "TASKTYPENAME",
          width: 200
        },
        {
          text: "执行状态",
          value: "TASKSTATENAME"
        },
        {
          text: "任务名称",
          value: "TASKNAME"
        },
        {
          text: "创建人",
          value: "CREATEUSERNAME"
        },
        {
          text: "创建时间",
          value: "CREATETIME"
        },
        {
          text: "执行人",
          value: "EXCUTEUSERNAME"
        }
      ]
    };
  },
  props: {
    tableHeight: {
      type: [String, Number],
      default: function() {
        return ($(window).height() - 240).toString();
      }
    },
    isTemplate:{//是否是模板
        type: Boolean,
        default:false,
    },
    isShowButton:{//是否显示按钮，不显示按钮不需要触发dispatch("changeCurTask"）
      type: Boolean,
      default:true,
    },
    isStore:{//是否用store方式显示数据
      type:Boolean,
      default:true
    },
    tableData:{//表数据
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  computed: {
    ...mapState({
      userId: state => state.task.userId,
      ServerCenterIds: state => state.task.ServerCenterIds,
      createIdentity: state => state.task.createIdentity,
      contactId: state => state.user.ContactID,
      realName: state => state.task.realName,
      departmentId: state => state.user.departmentId,
      departmentName: state => state.user.departmentName,
      companyId: state => state.user.companyId,
      companyName: state => state.user.companyName,
      GroupCurrent: state => state.task.taskGroupCurrent,
      copyInfo: state => state.folder.copyInfo,
      taskSource: state => state.task.taskSource,
      isCheckbox: state => state.task.isCheckbox,
      loading: state => state.task.loading,
      Person: state => state.folder.Person,
      taskStyle: state => state.task.taskStyle,
      taskParas: state => state.task.taskParas,
    }),
    formatData() {
      let tmp = this.taskGroupCurrent;
      const func = treeToArray;
      const args = [tmp, this.expandAll];
      return func.apply(null, args);
    }
  },
  mounted() {
    this.$store.commit("getTaskGroup", this.taskSource);
  },
  created() {
    this.TaskType = JSON.parse(localStorage.getItem("TaskType"));
  },
  methods: {
    getList(){
      this.$store.dispatch("changeTaskSource");
    },
    getTaskType(row) {
      // this.TaskType=this.TaskType || ;
      let tasktype = JSON.parse(localStorage.getItem("TaskType"));
      let typelist = tasktype.filter(item => item.ID == row.TASKTYPE);
      if (typelist.length > 0) {
        return row.childrens
          ? "icon-weibiaoti5"
          : 'icon-'+typelist[0].ICON
          ? typelist[0].ICON
          : 'icon-'+"icon-renwu5";
      } else {
        return "icon-renwu5";
      }
    },
    editShow(task) {
        let viewType = this.TaskType.filter(
            item => item.ID === task.TASKTYPE
        );
        this.$refs.CreateTask.OpenDialog(viewType[0], 1,this.taskStyle);
    }, 
    timeFormat(time) {
      // 时间格式化
      return time.substring(0, 19).replace("T", " ");
    },
    changeCurTask(row){
      if(this.isShowButton){
          this.$store.commit("changeCurTask", row);
      }
    },
    onclick(row) {
      if (row) {
        if(!this.isStore){
          this.$emit('onclick',row);
        }else{
          console.log("单击--row", row);
          this.changeCurTask(row);
          this.$parent.changeCurTask(row);
        }
      }
    },
    showRow(row) {
      // 是否展示子任务
      const show = row.row.parent
        ? row.row.parent._expanded && row.row.parent._show
        : true;
      row.row._show = show;
      return show
        ? "animation:treeTableShow 1s;-webkit-animation:treeTableShow 1s;"
        : "display:none;";
    },
    toggleExpanded(trIndex) {
      // 切换下级是否展开
      const record = this.formatData[trIndex];
      record._expanded = !record._expanded;
    },
    iconShow(index, record) {
      // 图标显示
      return index === 0 && record.children && record.children.length > 0;
    },
    handleCurrentChange(row) {
      // 选中行数据
      if (row) {
        console.log("单击--row", row);
         this.changeCurTask(row);
        this.$parent.changeCurTask(row);
      }
    },
    dbclick(row) {
      //双击行事件
      if(this.taskParas.CreateUserIds=='super' && this.userId!='super'){

      }
      else if(this.isTemplate){
          this.editShow(row);
      }else{
        // if (row.childrens) {
        //   this.$store.commit("setTaskGroupCurrents", row.ID);
        // } else {
        //   this.$store.dispatch("changeCurTask", row);
        //   this.openBlank(row.ID);
        // }
        if(!this.isStore){
          this.$emit('dbclick',row);
        }else{
          if (row.TASKTYPE == "E9354DE41375") {
            this.$store.commit("changeCurTask", {});
            this.GetSubTaskTreePathByTaskId(row.ID, row);
          } else {
              this.changeCurTask(row);
              this.openBlank(row);
          }
        }
      }
    },
    GetSubTaskTreePathByTaskId(taskId, row) {
      GetSubTaskTreePathByTaskId(taskId, this.userId).then(result => {
          if (result.length > 0) {
              this.$store.commit("setTaskGroupCurrentData", {
                  taskGroupCurrent: result,
                  row: row
              });
          } else {
              this.$store.commit("setTaskGroupCurrentData", {
                  taskGroupCurrent: [],
                  row: row
              });
          }
      });
    },
    liContextmenu(row) {
      if(this.isTemplate==0){
        this.contextmenuRow = row;

        //  event.preventDefault();
        const postition = {
          top: event.clientY,
          left: event.clientX
        };
        this.$refs.contextMenu.Show(postition);
      }
    },
    open() {
      this.dbclick(this.contextmenuRow);
    },
    workRecordDetail() {
      this.taskIds = AllChildNode(this.contextmenuRow, "ID");
      this.$refs.workRecordDialog.OpenDialog(this.taskIds);
    },
    handleFolderMenuClick() {
      this.changeCurTask(this.contextmenuRow);
      this.openBlank(this.contextmenuRow);
    },
    openBlank(row) {
      let pars = {
        TaskId: row.ID,
        Person: this.Person
      };
      AddTaskViewHistory(pars).then(pmevent => {});
      let routeUrl = this.$router.resolve({
        path: "/task-detailspage",
        query: {
          taskid: row.ID,
          tasktype:row.TASKTYPE
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    // click(row){
    // 	//双击行事件
    // 	this.$store.dispatch("changeCurTask", row);
    // 	this.$refs.taskDetail.dialogVisible = true;
    // }
  },
  watch: {
    taskSource(newItems, oldItems) {
      this.$store.commit("getTaskGroup", newItems);
    },
    GroupCurrent(newData,oldData){
      if(this.isStore){
        this.taskGroupCurrent=newData;
      }
    },
    tableData(newData,oldData){
      if(!this.isStore){
        this.taskGroupCurrent=newData;
      }
    },
  }
};
</script>
<style scoped lang="less">
@keyframes treeTableShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes treeTableShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.sonTaskColor {
  color: #ffb84b;
}
.NameHighLight {
  cursor: pointer;
  color: #46a1ff;
}
.ms-tree-space {
  position: relative;
  top: 1px;
  display: inline-block;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  width: 18px;
  height: 14px;
}
.ms-tree-space::before {
  content: "";
}
.processContainer {
  width: 100%;
  height: 100%;
  margin-bottom: 40px;
}
table td {
  line-height: 26px;
}
.tree-ctrl {
  position: relative;
  cursor: pointer;
  color: #2196f3;
  margin-left: -18px;
  margin-right: 5px;
}
.icon {
  font-size: 30px;
}
.viewbox {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.alSvgIcon {
  width: 1.4em;
  height: 1.4em;
  fill: currentColor;
  overflow: hidden;
}
.svgshow {
  display: flex;
  align-items: center;
  width: 70px;
  height: 70px;
  justify-content: center;
}
.svgshow:hover {
  color:#fff;
  background-color: rgb(25,172,249);
  border-radius: 5px;
}
</style>
<style scoped lang="scss">
.container {
  // display: table;
  margin-right: 20px;
  // height: 100%;
  // position: fixed;
  margin: -8px;
  background: white;
  margin-top: 3px;
  margin-left: 0px;
  .line {
    height: 30px;
    margin-top: 30px;
    background-color: #f1f1f1;
  }
  ul {
    /*ul向div父元素右方浮动*/
    list-style: none;
    /*将默认的列表符号去掉*/
    margin: 0;
    /* 将默认的内边距去掉 */
    padding: 2px;
    /* 将默认的外边距去掉 */
  }
  li {
    // list-style: none;
    margin: 10px 0px 0px 10px;
    padding: 10px 10px 10px 10px;
    float: left;
    width: 120px;
    height: 120px;
    text-align: center;
    font-size: 16px;
    color: #5b6379;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: 1.6rem;
    // text-align: center;
    // white-space: nowrap;
  }

  .iconfont {
    font-size: 40px;
  }

  .title {
    display: flex;
    align-items: center;
    font-family: 'Microsoft YaHei';
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    // text-align: left;
    -webkit-box-orient: vertical;
    // font-size: 16px;
    color: rgb(51,51,51);
    font-weight: 900;
    margin-top: 15px;
  }
}
</style>
